import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "11",
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.8077 1.58948L5.37038 10.4178L0.390625 6.5934L1.60882 5.00721L4.9624 7.58276L10.1917 0.411133L11.8077 1.58948Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }